import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { User } from 'src/app/core/models/user';
import { UserService } from 'src/app/core/services/user.service';
import { EventoService } from 'src/app/sigeve/evento/evento.service';
import { EventoMenu } from 'src/app/sigeve/evento/models/evento';
import { AppComponent } from '../../app.component';
import { AppMainComponent } from '../../app.main.component';

@Component({
  selector: 'app-topbar',
  templateUrl: './app.topbar.component.html'
})
export class AppTopBarComponent {
  user$: Observable<User>;
  
    constructor(public app: AppComponent, public appMain: AppMainComponent, private router:Router, private userService: UserService) {
      
    }

    ngOnInit(): void {
      this.user$ = this.userService.getUser();
 
     }

     alterarSenha(){
      this.router.navigate(['alterar-senha']);
     }

     logout(){
      this.userService.logout();
      this.redirectToLogin();
      setTimeout(() => {
          this.redirectToLogin();
      }, 300 );

  }

  redirectToLogin(){
      this.router.navigate(['/login']);
          
  }

 
}
